import api from 'api';

export const loadStatusTemplates = api('GET /api/templates/:pageId');

export const exportTemplate = api('GET /api/templates/:pageId/:name', {
  responseType: 'blob',
});
